import { POSTClockingItemBody, PUTClockingItemBody } from './index'
import { IPaginatedRequest } from '../../request'

export const listClockingItems = (params: IPaginatedRequest, shopID?: string) => ({
  method: 'GET',
  url: '/modules/clocking-items',
  params,
  headers:
    shopID &&
    new Headers({
      'X-Current-Shop-ID': shopID
    })
})

export const getClockingItem = (uuid: string) => ({
  method: 'GET',
  url: `/modules/clocking-items/${uuid}`
})

export const createClockingItem = (body: POSTClockingItemBody) => ({
  method: 'POST',
  url: '/modules/clocking-items',
  data: body
})

export const updateClockingItem = (uuid: string, body: PUTClockingItemBody) => ({
  method: 'PUT',
  url: `/modules/clocking-items/${uuid}`,
  data: body
})
